import trim from 'lodash/trim';

export function decode(code) {
  return decodeURIComponent(code.replace(/\+/g, ' '));
}

export function encode(value) {
  return encodeURIComponent(value).replace(/'/g, '%27').replace(/"/g, '%22');
}

export function parseLocation(locationStr) {
  const START = '^';
  const END = '$';
  const suburbGroup = '(?:(.*?))';
  const stateGroup = '(?:,\\s(WA|wa|NT|nt|SA|sa|QLD|qld|NSW|nsw|ACT|act|VIC|vic|TAS|tas|NZ|nz|))';
  const postcodeGroup = '(?:\\s(\\d{4}))';

  const allRegex = `${START}${suburbGroup}?${stateGroup}?${postcodeGroup}?${END}`;

  const [, localityWithPlus, subdivision, postcode] = new RegExp(allRegex, 'g').exec(locationStr);
  const locality = localityWithPlus.replace(/\+/g, ' ').trim();

  return {
    locality,
    subdivision,
    postcode,
  };
}

export function properUpperCase(str, sep) {
  const lowerCaseStr = (str || '').toString().toLowerCase();

  const separator = Array.isArray(sep) ? sep : (sep ? [sep] : []); // eslint-disable-line no-nested-ternary
  separator.push('\\s');

  const r = new RegExp(`(?:^|${separator.join('|')})\\S`, 'g');

  return lowerCaseStr.replace(r, s => s.toUpperCase());
}

export function stringifyLocation(loc) {
  const location = loc || {};
  return trim(
    trim(
      `${properUpperCase(location.locality, ' ')}, ${
        (location.subdivision || '').toLocaleUpperCase()} ${
        location.postcode || ''}`,
    ), ',');
}
